// src/components/pages/OtherPages.jsx
import React from 'react';

// Componente genérico para páginas en desarrollo
const ComingSoonPage = ({ icon, title, description }) => {
  return (
    <div className="h-full flex items-center justify-center bg-gray-50">
      <div className="text-center max-w-md p-8">
        <div className="text-8xl mb-6">{icon}</div>
        <h1 className="text-3xl font-bold text-gray-800 mb-4">{title}</h1>
        <p className="text-gray-600 mb-8">{description}</p>
        <div className="inline-block px-6 py-3 bg-blue-100 text-blue-800 rounded-full font-medium">
          Próximamente
        </div>
      </div>
    </div>
  );
};

// Mensajes Rápidos
export const QuickMessages = () => (
  <ComingSoonPage
    icon="⚡"
    title="Mensajes Rápidos"
    description="Crea y gestiona plantillas de mensajes para responder más rápido a tus clientes."
  />
);

// Automatizaciones
export const Automations = () => (
  <ComingSoonPage
    icon="🤖"
    title="Automatizaciones"
    description="Configura flujos automáticos para responder mensajes y ahorrar tiempo."
  />
);

// Biblioteca de Media
export const MediaLibrary = () => (
  <ComingSoonPage
    icon="🖼️"
    title="Biblioteca de Media"
    description="Organiza y gestiona todas tus imágenes, videos y archivos compartidos."
  />
);

// Estadísticas
export const Statistics = () => (
  <ComingSoonPage
    icon="📊"
    title="Estadísticas"
    description="Visualiza métricas detalladas sobre tus conversaciones y rendimiento."
  />
);

// Configuración
export const Settings = () => (
  <div className="h-full overflow-y-auto bg-gray-50">
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold text-gray-800 mb-2">Configuración ⚙️</h1>
      <p className="text-gray-600 mb-8">Gestiona la configuración de tu cuenta</p>

      {/* Secciones de configuración */}
      <div className="space-y-6">
        {/* Perfil */}
        <div className="bg-white rounded-xl shadow-md p-6">
          <h2 className="text-xl font-bold text-gray-800 mb-4">Perfil</h2>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Nombre de la empresa
              </label>
              <input
                type="text"
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Mi Empresa"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Email de contacto
              </label>
              <input
                type="email"
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="contacto@miempresa.com"
              />
            </div>
          </div>
        </div>

        {/* Notificaciones */}
        <div className="bg-white rounded-xl shadow-md p-6">
          <h2 className="text-xl font-bold text-gray-800 mb-4">Notificaciones</h2>
          <div className="space-y-3">
            <label className="flex items-center justify-between">
              <span className="text-gray-700">Notificar nuevos mensajes</span>
              <input type="checkbox" className="toggle" defaultChecked />
            </label>
            <label className="flex items-center justify-between">
              <span className="text-gray-700">Sonido de notificación</span>
              <input type="checkbox" className="toggle" defaultChecked />
            </label>
            <label className="flex items-center justify-between">
              <span className="text-gray-700">Notificaciones de escritorio</span>
              <input type="checkbox" className="toggle" />
            </label>
          </div>
        </div>

        {/* API Keys */}
        <div className="bg-white rounded-xl shadow-md p-6">
          <h2 className="text-xl font-bold text-gray-800 mb-4">Integraciones</h2>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                API Key de Gemini
              </label>
              <div className="flex gap-2">
                <input
                  type="password"
                  className="flex-1 px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="••••••••••••••••"
                />
                <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
                  Guardar
                </button>
              </div>
              <p className="text-xs text-gray-500 mt-1">
                Para generar contenido con IA
              </p>
            </div>
          </div>
        </div>

        {/* Botón guardar */}
        <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-xl transition-colors">
          Guardar cambios
        </button>
      </div>
    </div>
  </div>
);
